import { Component, EventEmitter, Input, Output } from '@angular/core';
import { APPCONFIG } from '../../config'
import { AdalService } from '../../shared/adal.service';
import { UserService } from '../../services/UserService';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'my-app-header',
    styles: [require('./header.component.css')],
    template: require('./header.component.html')
})

export class AppHeaderComponent {
    @Input() isSideNavOpen=false;
    @Input() inLicensePortal=false;
    @Output() menuToggle = new EventEmitter<void>();
    selectedTitle: '';
    IsAdmin:boolean;  
    errorMessage: string;   

    username:string;
     constructor(private adalService: AdalService, private userservice: UserService,private router: Router,) {                                      
        this.username= localStorage.getItem('Name') ;
    }

    AppConfig: Object;
    OnChanges(){
        console.log(this.isSideNavOpen)
    }
    onMenuClick(){
        this.menuToggle.emit();
    }
    ngOnInit() {
        this.getUserRights(Number(localStorage.getItem('userid')));
        this.AppConfig = APPCONFIG;
    }

    logOut(): void {            
        localStorage.clear();
        this.adalService.logout();               
    }

    getStyle(selected) {        
        this.selectedTitle = selected;
    }

    removeStyle(){
        this.selectedTitle = '';
    }

    redirectuser() {
        
        this.router.navigate(["/user-management/user"]);
    }

    getUserRights(UserId){
        
        this.userservice.getUserById(UserId).subscribe(
            Data => {                                      
                this.IsAdmin = Data.IsAdmin;
            },
             error => {
                this.errorMessage = error;
            });
    }
    redirectToHomePage(){
        this.router.navigate(['/home-page'])
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/header/header.component.ts